/**
 * @desc undefined
 */
import { AppInfo } from '@eastcoal/api/gateway/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ShouldRefreshParameter = AppInfo

const method = 'GET'
const url = '/gateway/gateway/cipher/refresh'

export const shouldRefreshApi = (
  params?: ShouldRefreshParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<boolean>({
    method,
    url,
    params,
    ...config
  })
}

shouldRefreshApi.method = method
shouldRefreshApi.url = url
